import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { fmt } from '../../utils';
import type { PieSlice } from './pieSlices';

/** Наведённая доля: recharts кладёт исходный элемент данных в `payload`. */
type TooltipItem = {
  payload?: PieSlice;
};

type Props = {
  /** Курсор на диаграмме: без наведения recharts зовёт содержимое подсказки с `false` */
  active?: boolean;
  payload?: readonly TooltipItem[];
};

/**
 * Подсказка доли круговой диаграммы: подпись, величина и доля в целом.
 *
 * Доля берётся из самих данных, а не из расчёта recharts: круг строится по уже посчитанным
 * долям ({@link PieSlice}), и второй счёт того же числа разошёлся бы с ним округлением.
 */
export const PieSliceTooltip: FC<Props> = ({ active, payload }) => {
  const { t } = useTranslation('qualityDashboard');

  const slice = payload?.[0]?.payload;
  if (!active || !slice) return null;

  return (
    <div className="rounded-md border bg-popover px-3 py-2 text-xs text-popover-foreground shadow">
      {t('presets.chart.sliceTooltip', {
        label: slice.label,
        value: fmt(slice.value),
        share: fmt(slice.share * 100),
      })}
    </div>
  );
};
